import type { AgentMode, AgentStatus } from './sdk';

export const OZT_EVENT_PREFIX = 'ozt_';

export const hasOztPrefix = (eventType?: string): eventType is `ozt_${string}` =>
  typeof eventType === 'string' && eventType.startsWith(OZT_EVENT_PREFIX);

export interface OztSetModePayload {
  mode: AgentMode;
  status: AgentStatus;
  reconnect: boolean;
}

export interface OztPhoneNumberPayload {
  phoneNumberToHold?: number;
}

export type CustomOztHandlerName = 'onCallRecording';
